import { useCallback, useRef } from 'react';
import { t } from '@lingui/core/macro';
import { Tooltip, pxToRem } from '@pocketlaw/tetris';
import { SidebarDraggableLine } from '../styled';
import { useDraggableWidth } from '../useDraggableWidth';
import { FLOATING_SIDEBAR_CSS_VARIABLE_WIDTH, FloatingSidebarContainer, FloatingSidebarDraggableHover } from './styled';
export function Root(props) {
    const { open, initialWidth = 'narrow', children } = props;
    const containerRef = useRef(null);
    const setWidth = useCallback((width) => {
        var _a;
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty(FLOATING_SIDEBAR_CSS_VARIABLE_WIDTH, pxToRem(width));
    }, []);
    const { dragging, onDraggableMouseDown } = useDraggableWidth(setWidth);
    return (<FloatingSidebarContainer ref={containerRef} $open={open} $initialWidth={initialWidth}>
      {children}
      <Tooltip side="left" delay={1000} disabled={dragging} title={t({
            message: 'Drag to resize',
            comment: 'Sidebar - Resize tooltip label',
        })}>
        <FloatingSidebarDraggableHover $isDragging={dragging} onMouseDown={onDraggableMouseDown}>
          <SidebarDraggableLine />
        </FloatingSidebarDraggableHover>
      </Tooltip>
    </FloatingSidebarContainer>);
}
